var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meeting-canceled-tips"},[_c('img',{attrs:{"src":require("../../assets/images/icons/warning.png"),"alt":"","width":"80","height":"80"}}),_c('span',{staticClass:"meeting-status"},[_vm._v(_vm._s(_vm.$t('meeting.hasCanceled')))]),_c('span',{staticClass:"meeting-tips"},[_vm._v(_vm._s(_vm.$t('meeting.cancelMeetingInfo')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }